import { render, staticRenderFns } from "./shop-info.vue?vue&type=template&id=dd207cfe&scoped=true&"
import script from "./shop-info.vue?vue&type=script&lang=js&"
export * from "./shop-info.vue?vue&type=script&lang=js&"
import style0 from "./shop-info.vue?vue&type=style&index=0&id=dd207cfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd207cfe",
  null
  
)

export default component.exports